import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CreativeTemplate} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import {SharePermission} from 'common/src/modules/sharing/sharing.types';
import {CreativeTemplatesLibraryState} from './creativeTemplatesLibrary.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

const creativeTemplatesLibraryInitialState: CreativeTemplatesLibraryState = {
  templates: [],
  sharePermissions: [],
  isPreviewOpen: false,
  selectedTemplatesIds: [],
  aiFilter: {
    aiFilteredIds: [],
    query: '',
  },
};

const creativeTemplatesLibraryReducer = createSlice({
  name: BreadcrumbName.CreativeTemplatesLibrary,
  initialState: creativeTemplatesLibraryInitialState,
  reducers: {
    resetState: () => creativeTemplatesLibraryInitialState,
    setTemplatesLibraryData: (
      state,
      action: PayloadAction<{templates: CreativeTemplate[]; sharePermissions: SharePermission[]}>,
    ) => {
      state.templates = action.payload.templates;
      state.sharePermissions = action.payload.sharePermissions;
    },

    closePreview: (state) => {
      state.selectedTemplatesIds = [];
      state.isPreviewOpen = false;
    },

    setSelectedTemplateIds: (state, action: PayloadAction<number[]>) => {
      state.selectedTemplatesIds = action.payload;
    },

    showPreviewForTemplateId: (state, action: PayloadAction<number>) => {
      state.selectedTemplatesIds = [action.payload];
      state.isPreviewOpen = true;
    },

    setAiCreativeTemplatesFilter: (
      state,
      action: PayloadAction<{aiFilteredIds: number[]; query: string}>,
    ) => {
      state.aiFilter = action.payload;
    },
  },
});

const {
  resetState,
  setTemplatesLibraryData,
  closePreview,
  setSelectedTemplateIds,
  showPreviewForTemplateId,
  setAiCreativeTemplatesFilter,
} = creativeTemplatesLibraryReducer.actions;

export {
  resetState,
  setTemplatesLibraryData,
  closePreview,
  setSelectedTemplateIds,
  showPreviewForTemplateId,
  setAiCreativeTemplatesFilter,
};

export default creativeTemplatesLibraryReducer.reducer;
